// extracted by mini-css-extract-plugin
export default {"Container":"BranchDescription-module__Container--PvPp6","ActionGroup":"BranchDescription-module__ActionGroup--e2Tcc"};